<template>
  <div class="w-full pb-24" :class="route.name === `index___${locale}` ? 'pb-24':'py-14 lg:py-28'">
    <div class="container-1 space-y-6">
      <div v-if="route.name === `index___${locale}`">
        <div class="uppercase md:text-[1.4vw] lg:text-[1.1vw] font-semibold figtree bg-[#AEEDEA] text-[#313187] px-2 py-1 rounded mb-1 inline-block">Our Client</div>
        <div class="text-[32px] leading-[38px] md:text-[2.4vw] md:leading-[2.8vw] lg:text-[2.2vw] lg:leading-[2.6vw] font-semibold figtree text-[#313187]">ImpacThink Portfolio</div>
      </div>
      <div v-else>
        <div class="uppercase text-[32px] leading-[38px] md:text-[2.4vw] md:leading-[2.8vw] lg:text-[2.2vw] lg:leading-[2.6vw] font-semibold figtree bg-[#AEEDEA] text-[#313187] px-2 py-1 rounded mb-1 inline-block">Our Client</div>
        <div class="invisible text-[32px] leading-[38px] md:text-[2.4vw] md:leading-[2.8vw] lg:text-[2.2vw] lg:leading-[2.6vw] font-semibold figtree text-[#313187]">Proud to Have Served</div>
      </div>
      <div>
        <div class="">
          <div v-for="(item, i) in items" :class="`client-item-${i}`" class="max-w-[30rem] pl-6 relative pb-12">
            <div v-if="i !== items.length - 1" class="absolute w-[1px] h-full top-0 left-1 bg-gray-100">
              <div :class="`client-progress`" class="w-[1px] bg-primary transition-all duration-100"></div>
            </div>
            <div :class="[{'active': items.isActive}]" class="circle circle-outer absolute w-[10px] h-[10px] rounded-full -top-[2.6px] -left-[0.4px] bg-white flex items-center justify-center">
              <div class="circle circle-inner w-[4px] h-[4px] rounded-full"></div>
            </div>
            <figure class="aspect-video rounded-lg overflow-hidden max-w-[160px]">
              <img :src="config.public.cdnUrl+config.public.cdnFolder+item.img_src" alt="" class="w-full h-full object-cover">
            </figure>
            <div class="figtree text-[20px] leading-[24px] text-primary font-bold mt-3">{{ item.title[lang] }}</div>
            <div class="figtree text-[16px] leading-[24px] font-semibold mt-3">{{ item.subtitle[lang] }}</div>
            <div class="figtree text-[14px] leading-[24px] mt-3" v-html="item.description[lang]"></div>
          </div>
        </div>
        <!-- <div>
          <NuxtLink class="btn btn-inline primary inline-flex items-center group">
            See More
            <svg class="group-hover:translate-x-2 transition" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_840_3311)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.4683 5.66174C5.4683 5.10945 5.91601 4.66174 6.4683 4.66174L14.9536 4.66174C15.5059 4.66174 15.9536 5.10945 15.9536 5.66174L15.9536 14.147C15.9536 14.6993 15.5059 15.147 14.9536 15.147C14.4013 15.147 13.9536 14.6993 13.9536 14.147L13.9536 8.07595L5.76119 16.2683C5.37066 16.6589 4.7375 16.6589 4.34697 16.2683C3.95645 15.8778 3.95645 15.2447 4.34697 14.8541L12.5394 6.66174L6.4683 6.66174C5.91601 6.66174 5.4683 6.21402 5.4683 5.66174Z" fill="#AEEDEA"/>
              </g>
              <defs>
              <clipPath id="clip0_840_3311">
              <rect width="20" height="20" fill="white" transform="translate(20 0.612305) rotate(90)"/>
              </clipPath>
              </defs>
            </svg>
          </NuxtLink>
        </div> -->
        <div v-if="!noMore" id="load-more-mobile" class="flex justify-center">
          <button class="">
            <span class="loading loading-spinner loading-xs text-primary"></span>
          </button>
        </div>

        <div class="w-full flex justify-center mt-12" data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200">
          <button
            @click="toggleContactModal"
            class="figtree group rounded-3xl h-full py-2 px-3 lg:py-3 lg:px-6 w-fit hover:bg-ip-color-2 bg-ip-color-3 hover:shadow-lg font-semibold text-base md:text-[1.4vw] lg:text-[1.1vw] hover:text-ip-color-3 text-white flex items-center gap-1 transition-colors duration-300">
              Contact Us
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300">
                <path fill-rule="evenodd" d="M4.22 11.78a.75.75 0 0 1 0-1.06L9.44 5.5H5.75a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V6.56l-5.22 5.22a.75.75 0 0 1-1.06 0Z" clip-rule="evenodd" />
              </svg>
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
 
import { ref, computed, onMounted, nextTick, watch } from 'vue';
import { useRoute, useRuntimeConfig } from '#imports';
import { useNavbarStore } from '@/store/navbar';

 
const lang = ref('id')
const config = useRuntimeConfig();
const route = useRoute();
const locale = ref('en')
const props = defineProps(['items', 'noMore']);
const emits = defineEmits(['loadMore']);
const currentIndex = ref(0);
const loadMore = ref(false);

const observers = [];
const moreObserver = ref(null);

onMounted(() => {
  if (process.client) {
    nextTick(() => {
      startObserver();
    });
  }
});

const disconnectObservers = () => {
  observers.forEach(observer => observer.disconnect());
  if (moreObserver.value) moreObserver.value.disconnect();
};

const startObserver = () => {
  disconnectObservers();
  nextTick(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: [0.0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1.0],
    };
    props.items.forEach((item, index) => {
      const el = document.querySelector('.client-item-' + index);
      const callback = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (index !== 0) {
              document.querySelector(`.client-item-${index - 1} .client-progress`).style.height = `${entry.intersectionRatio * 100}%`;
            }
            if (entry.intersectionRatio >= 1.0) {
              document.querySelector(`.client-item-${index} .circle.circle-outer`).classList.add('active');
            } else {
              document.querySelector(`.client-item-${index} .circle.circle-outer`).classList.remove('active');
            }
          } else {
            if (document.querySelector(`.client-item-${index - 1} .client-progress`)) document.querySelector(`.client-item-${index - 1} .client-progress`).style.height = `${0}%`;
            document.querySelector(`.client-item-${index} .circle.circle-outer`).classList.remove('active');
          }
        });
      };
      observers[index] = new IntersectionObserver(callback, options);
      if (el) observers[index].observe(el);
    });

    const moreCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadMore.value = true;
        }
      });
    };

    const moreEl = document.querySelector('#load-more-mobile');
    if (moreEl) {
      moreObserver.value = new IntersectionObserver(moreCallback, options);
      moreObserver.value.observe(moreEl);
    }
  });
};

const navbarStore = useNavbarStore();
const toggleContactModal = () => {
  navbarStore.toggleContact();
};

watch(() => loadMore.value, (val) => {
  if (val) {
    emits('loadMore');
  }
});

watch(() => props.items.length, (val) => {
  if (val) {
    startObserver();
    nextTick(() => {
      loadMore.value = false;
    });
  }
});
</script>

<style lang="scss" scoped>
.circle-outer{
  @apply transition-all;
  .circle-inner {
    @apply bg-[#cdcdcd];
  }
  &.active {
    animation: bounce 450ms;
    animation-timing-function: linear;
    @apply border border-[#313187];
    .circle-inner {
      @apply bg-[#313187];
    }
  }
}

@keyframes bounce {
  25% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.4);
  }
  75% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1.1);
  }
}

</style>
